import React from 'react'
import { useSelector } from 'react-redux'

import './FamilyMemberLabel.css'

export const FamilyMemberLabel = ({ className, patientId }) => {
  const { activeMembers } = useSelector(state => state.account)
  const userDetails = useSelector(state => state.profile.userDetails)

  const isSelf = userDetails?.id?.toString() === patientId?.toString()

  const currentPatient = isSelf
    ? userDetails
    : activeMembers?.find(
        patient => patient?.id?.toString() === patientId?.toString()
      )

  return (
    <div
      className={`family-member-label ${className}`}
      style={{
        backgroundColor: isSelf ? 'var(--success)' : currentPatient?.color,
      }}
    >
      <span className="family-member-name tiny light">
        {currentPatient?.firstName}
      </span>
    </div>
  )
}

export default FamilyMemberLabel
